export default __webpack_public_path__ + "static/media/pictogramBeaconUncategorised48.191f9c80.svg";